import type { Section, SectionGroup, SubSection } from './menuMap';

export type { Section, SectionGroup, SubSection } from './menuMap';

export const isSectionGroup = (section: Section): section is SectionGroup =>
  'subSections' in section;

export const getSectionItems = (section: Section): SubSection[] => {
  if (isSectionGroup(section)) {
    return section.subSections;
  }
  return [section];
};

export const firstAccessibleMenuPath = (sections: Section[]) =>
  sections.flatMap((sect) => getSectionItems(sect))[0]?.path;

export const getSubSectionName = (
  translateBackendString: (translatedObject: unknown) => string,
  subSectionName: SubSection['name'],
) =>
  typeof subSectionName === 'string'
    ? subSectionName
    : translateBackendString(subSectionName);

export const isNavSubSectionPathActive = (
  sub: Pick<SubSection, 'path'>,
  pathname: string,
): boolean => {
  if (sub.path === '/') {
    return pathname === '/';
  }
  return pathname === sub.path || pathname.startsWith(`${sub.path}/`);
};
